'use client';

import { createFileRoute } from '@tanstack/react-router';

import { RiskDashboard } from '@/features/rsk/components/RiskDashboard';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/risks/dashboard')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.riskRegister', { defaultValue: 'Risk dashboard' }),
  }),
  component: RiskDashboardPage,
});

function RiskDashboardPage() {
  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <RiskDashboard />
      </div>
    </div>
  );
}
